const FlyingController = ['$scope', '$rootScope', '$cookies', '$http', '$lazyScripts', function($scope, $rootScope, $cookies, $http, $lazyScripts) {


    let interacted = false;
    let available = {
        'orientationchange': window,
        'resize': window,
        'scroll': document,
        'mousemove': document,
        'keydown': document,
        'click': document,
        'touchstart': document,
    };

    $scope.flying = {
        client: null,
        tracker: null,
        visible: false,
        dismiss: (event) => {
            event.preventDefault();
            $http.get('/service/dismiss?dismiss=flying').then(() => {
                $scope.flying.visible = false;
                if ( this.tracker !== null ) {
                    this.tracker.track('skip');
                }
            });

        },
        track: (link) => {
            if ( this.tracker !== null ) {
                this.tracker.track('clickthrough');
            } else {
                $http.post(link);
            }
        },
        display: () => {
            if ( $scope.service.flying.vast !== null ) {
                $lazyScripts.loadVast().then(() => {
                    this.client = new VAST.VASTClient();
                    this.client.get($scope.service.flying.vast).then(res => {
                        if ( res.hasOwnProperty('ads') && res.ads.length !== 0 ) {
                            this.tracker = new VAST.VASTTracker(this.client, res.ads[0], res.ads[0].creatives[0]);
                            this.tracker.load();
                            this.tracker.trackImpression();

                            $scope.flying.visible = true;

                            $scope.service.flying.video = res.ads[0].creatives[0].mediaFiles[0].fileURL;
                            // Link href
                            $scope.service.flying.link = res.ads[0].creatives[0].videoClickThroughURLTemplate.url;

                            $scope.$apply();

                            $http.get($scope.service.flying.track + '?label=normal');
                        } else {
                            $http.get($scope.service.flying.track + '?label=empty');
                        }
                    });
                })
            } else {
                $http.get($scope.service.flying.trackView).then(() => {
                    $scope.flying.visible = true;
                    $scope.$apply();
                });
            }
        }
    };


    $scope.$watch('service.ready', (ready) => {
        if ( ready === true && $scope.service.flying !== false ) {
            let interacts = () => {
                if ( interacted === false ) {
                    for (const [key, value] of Object.entries(available)) {
                        value.removeEventListener(key, interacts);
                    }
                    $rootScope.$broadcast('user-interaction', true);
                }
            };
            for (const [key, value] of Object.entries(available)) {
                value.addEventListener(key, interacts, { passive: true });
            }

            $rootScope.$on('user-interaction', () => {
                $scope.flying.display();
            });

        }
    });

    $rootScope.$on('flying-play', () => {
        if ( $scope.flying.tracker !== null ) {
            $scope.flying.tracker.track('start');
        }
    });

    $rootScope.$on('flying-error', (e, o) => {
        if ( $scope.flying.tracker !== null ) {
            $http.post($scope.service.flying.error, {
                video: $scope.service.flying.video,
                media: o.media,
                network: o.network,
            });
        }
    });

}];

export default FlyingController;
